import { en } from './en/en';
import { de } from './de/de';

export const languages = {
    en,
    de
};
